import { Component } from '@angular/core';

@Component({
  selector: 'app-confirm-clear-bookmarks.dialog',
  templateUrl: './confirm-clear-bookmarks.dialog.component.html',
  styleUrl: './confirm-clear-bookmarks.dialog.component.scss'
})
export class ConfirmClearBookmarksDialogComponent {

}
